/**
 * 變數給外部用
 */
export const routeState = {
  /** 是否建立動態路由 */
  routeCreated: false,
};

// export default routeState;
